<script setup lang="ts">
const navStore = useNavStore()
const router = useRouter()
const mq = useMediaQuery()

const publicUrl = useEnvStore().getEnvVariable('VUE_APP_URL_PUBLIC')
const brandStore = useBrandStore()
const brandLogo = computed(() => brandStore.brandLogo)
const brandLogoMobile = computed(() => brandStore.brandLogoMobile)
const leaveRegistration = ref(false)

const showLeaveRegistrationModal = () => {
  leaveRegistration.value = true
}

const showGoBackButton = computed(() => {
  return router.currentRoute.value.meta.showGoBackButton
})

const showLeaveRegistrationImg = computed(() => {
  if (router.currentRoute.value.meta.showLeaveRegistrationImg !== undefined) {
    return router.currentRoute.value.meta.showLeaveRegistrationImg
  } else {
    return true
  }
})
let goBack: () => void

const goBackHandler = (callBack: () => void) => {
  if (callBack) {
    goBack = callBack
  } else {
    goBack = () => router.go(-1)
  }
}
</script>

<template>
  <OenUiNavBar>
    <XeLeaveRegistrationModal v-model="leaveRegistration" />
    <template #left>
      <OenUiBackButton v-if="!mq.sm && showGoBackButton" icon="<" @click="goBack" />
      <OenUiLink v-else :href="publicUrl" :aria-label="`${brandStore.brandName} Logo`">
        <img
          :src="mq.current === 'xs' ? brandLogoMobile : brandLogo"
          :alt="`${brandStore.brandName} Logo`"
        />
      </OenUiLink>
    </template>
    <template v-if="mq.current === 'xs'">
      {{ navStore.withoutStepperPageTile }}
    </template>
    <template #right>
      <OenUiButton v-if="showLeaveRegistrationImg" theme="icon" @click="showLeaveRegistrationModal">
        <IRmt4Close name="close" />
      </OenUiButton>
    </template>
  </OenUiNavBar>

  <div>
    <RouterView @go-back="goBackHandler" />
  </div>
</template>

<style scoped>
.navbar {
  @apply mb-0 border-b-0 !important;
}
</style>
